<app-navbar></app-navbar>

<section class="min-h-[50dvh] bg-white text-white">
    <div class="w-full">
        <div class="hero min-h-[60dvh]" style="background-image: url(/assets/img/excellence/tire_knowledge/657c36b0c4f9e2af385db6fe_3.webp);">
            <div class="hero-overlay"></div>
            <div class="my-28 text-center">
                <h3 class="text-4xl font-bold text-green-500 uppercase">{{texts.title}}</h3>
                <p class="text-base opacity-75 md:w-1/2 mx-4 md:mx-auto"> 
                    {{texts.subtitle}}
                </p>
            </div>
        </div>
    </div>


    <div class="px-4 mx-auto">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-2 py-5">
            <!-- Component: Image overlay card -->
            <div class="w-full">
                <div class="h-full rounded bg-cover" style="background-image: url(/assets/img/excellence/tire_knowledge/658423494373cdeefc9ba88e_TK_Basics-p-1080.jpg);">

                    <div class="text-left flex flex-col h-full rounded justify-end bg-gradient-to-t from-neutral-950 p-6 pt-48">
                        <p class="text-sm">{{texts.posts[0].hashtag}}</p>
                        <h3 class="text-2xl font-extrabold text-green-500 uppercase">{{texts.posts[0].title}}</h3>
                        <p class="text-base opacity-75">{{texts.posts[0].subtitle}}</p>
                        <a class="w-32 mt-2 inline-flex items-center justify-center h-8 gap-2 px-3 text-xs font-medium tracking-wide border rounded-full 
                        focus-visible:outline-none whitespace-nowrap border-green-500 text-green-500 hover:border-green-600 hover:text-green-600
                        hover:scale-110 transition-transform duration-200 hover:bg-black" 
                         href="/excellence/tire-knowledge/basic-definitions" routerLink="/excellence/tire-knowledge/basic-definitions">
                            <span>{{texts.saber_mas}}</span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="w-full">
                <div class="h-full rounded bg-cover" style="background-image: url(/assets/img/excellence/tire_knowledge/65a7b841e64da8a2cc35cad5_readtires-65a7b82542fc6-p-1080.webp);">

                    <div class="text-left flex flex-col h-full rounded justify-end bg-gradient-to-t from-neutral-950 p-6 pt-48">
                        <p class="text-sm">{{texts.posts[1].hashtag}}</p>
                        <h3 class="text-2xl font-extrabold text-green-500 uppercase">{{texts.posts[1].title}}</h3>
                        <p class="text-base opacity-75">{{texts.posts[1].subtitle}}</p>
                        <a class="w-32 mt-2 inline-flex items-center justify-center h-8 gap-2 px-3 text-xs font-medium tracking-wide border rounded-full 
                        focus-visible:outline-none whitespace-nowrap border-green-500 text-green-500 hover:border-green-600 hover:text-green-600
                        hover:scale-110 transition-transform duration-200 hover:bg-black" 
                        href="/excellence/tire-knowledge/how-to-read-tires" routerLink="/excellence/tire-knowledge/how-to-read-tires">
                            <span>{{texts.saber_mas}}</span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="w-full">
                <div class="h-full rounded bg-cover" style="background-image: url(/assets/img/excellence/tire_knowledge/6584233c077d6f20b1ce80be_TK_TireStructure-p-1080.jpg);">

                    <div class="text-left flex flex-col h-full rounded justify-end bg-gradient-to-t from-neutral-950 p-6 pt-48">
                        <p class="text-sm">{{texts.posts[2].hashtag}}</p>
                        <h3 class="text-2xl font-extrabold text-green-500 uppercase">{{texts.posts[2].title}}</h3>
                        <p class="text-base opacity-75">{{texts.posts[2].subtitle}}</p>
                        <a class="w-32 mt-2 inline-flex items-center justify-center h-8 gap-2 px-3 text-xs font-medium tracking-wide border rounded-full 
                        focus-visible:outline-none whitespace-nowrap border-green-500 text-green-500 hover:border-green-600 hover:text-green-600
                        hover:scale-110 transition-transform duration-200 hover:bg-black"
                         href="/excellence/tire-knowledge/tire-structure" routerLink="/excellence/tire-knowledge/tire-structure">
                            <span>{{texts.saber_mas}}</span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="w-full">
                <div class="h-full rounded bg-cover" style="background-image: url(/assets/img/excellence/tire_knowledge/658422c01d590139bce42c8e_TK_EV-p-1080.jpg);">

                    <div class="text-left flex flex-col h-full rounded justify-end bg-gradient-to-t from-neutral-950 p-6 pt-48">
                        <p class="text-sm">{{texts.posts[3].hashtag}}</p>
                        <h3 class="text-2xl font-extrabold text-green-500 uppercase">{{texts.posts[3].title}}</h3>
                        <p class="text-base opacity-75">{{texts.posts[3].subtitle}}</p>
                        <a class="w-32 mt-2 inline-flex items-center justify-center h-8 gap-2 px-3 text-xs font-medium tracking-wide border rounded-full 
                        focus-visible:outline-none whitespace-nowrap border-green-500 text-green-500 hover:border-green-600 hover:text-green-600
                        hover:scale-110 transition-transform duration-200 hover:bg-black"
                         href="/excellence/tire-knowledge/why-is-it-better-to-use-ev-tires-for-ev" routerLink="/excellence/tire-knowledge/why-is-it-better-to-use-ev-tires-for-ev">
                            <span>{{texts.saber_mas}}</span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="w-full">
                <div class="h-full rounded bg-cover" style="background-image: url(/assets/img/excellence/tire_knowledge/658422a4dea35aeef63f1ee8_TK_TireDifference-p-1080.jpg);">

                    <div class="text-left flex flex-col h-full rounded justify-end bg-gradient-to-t from-neutral-950 p-6 pt-48">
                        <p class="text-sm">{{texts.posts[4].hashtag}}</p>
                        <h3 class="text-2xl font-extrabold text-green-500 uppercase">{{texts.posts[4].title}}</h3>
                        <p class="text-base opacity-75">{{texts.posts[4].subtitle}}</p>
                        <a class="w-32 mt-2 inline-flex items-center justify-center h-8 gap-2 px-3 text-xs font-medium tracking-wide border rounded-full 
                        focus-visible:outline-none whitespace-nowrap border-green-500 text-green-500 hover:border-green-600 hover:text-green-600
                        hover:scale-110 transition-transform duration-200 hover:bg-black"
                         href="/excellence/tire-knowledge/what-is-the-difference-between-tires" routerLink="/excellence/tire-knowledge/what-is-the-difference-between-tires">
                           <span>{{texts.saber_mas}}</span>
                        </a>
                    </div>
                </div>
            </div>

            <div class="w-full">
                <div class="h-full rounded bg-cover" style="background-image: url(/assets/img/excellence/tire_knowledge/658422b3108d42fc5f008804_TK_SummerPressure-p-1080.jpg);">

                    <div class="text-left flex flex-col h-full rounded justify-end bg-gradient-to-t from-neutral-950 p-6 pt-48">
                        <p class="text-sm">{{texts.posts[5].hashtag}}</p>
                        <h3 class="text-2xl font-extrabold text-green-500 uppercase">{{texts.posts[5].title}}</h3>
                        <p class="text-base opacity-75">{{texts.posts[5].subtitle}}</p>
                        <a class="w-32 mt-2 inline-flex items-center justify-center h-8 gap-2 px-3 text-xs font-medium tracking-wide border rounded-full 
                        focus-visible:outline-none whitespace-nowrap border-green-500 text-green-500 hover:border-green-600 hover:text-green-600
                        hover:scale-110 transition-transform duration-200 hover:bg-black"
                         href="/excellence/tire-knowledge/what-should-your-tire-pressure-be-in-summer" routerLink="/excellence/tire-knowledge/what-should-your-tire-pressure-be-in-summer">
                            <span>{{texts.saber_mas}}</span>
                        </a>
                    </div>
                </div>
            </div>            
        </div>
    </div>
</section>
<app-footer></app-footer>